import { Component, input } from '@angular/core';
import { MemberModel } from '../../../../core/models/data/member.model';
import { AuditLogsComponent } from '../../../../parts/audit-logs/audit-logs.component';
import { AuditEntityType } from '../../../../core/enums/base.enums';

@Component({
  selector: 'ms-member-logs',
  imports: [AuditLogsComponent],
  templateUrl: './member-profile-logs.component.html'
})
export class MemberProfileLogsComponent {
  public member = input<MemberModel | undefined>(undefined);
  
  public AuditEntityType = AuditEntityType;
}
